var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99995 9.52628C5.60579 9.52628 4.47412 8.39461 4.47412 7.00044C4.47412 5.60628 5.60579 4.47461 6.99995 4.47461C8.39412 4.47461 9.52579 5.60628 9.52579 7.00044C9.52579 8.39461 8.39412 9.52628 6.99995 9.52628ZM6.99995 5.34961C6.08995 5.34961 5.34912 6.09044 5.34912 7.00044C5.34912 7.91044 6.08995 8.65128 6.99995 8.65128C7.90995 8.65128 8.65079 7.91044 8.65079 7.00044C8.65079 6.09044 7.90995 5.34961 6.99995 5.34961Z",
    fill: "#3D3962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99988 12.2616C4.80655 12.2616 2.73572 10.9783 1.31238 8.74995C0.694049 7.78745 0.694049 6.21828 1.31238 5.24995C2.74155 3.02161 4.81238 1.73828 6.99988 1.73828C9.18738 1.73828 11.2582 3.02161 12.6815 5.24995C13.2999 6.21245 13.2999 7.78161 12.6815 8.74995C11.2582 10.9783 9.18738 12.2616 6.99988 12.2616ZM6.99988 2.61328C5.11572 2.61328 3.31322 3.74495 2.05322 5.72245C1.61572 6.40495 1.61572 7.59495 2.05322 8.27745C3.31322 10.2549 5.11572 11.3866 6.99988 11.3866C8.88405 11.3866 10.6865 10.2549 11.9465 8.27745C12.384 7.59495 12.384 6.40495 11.9465 5.72245C10.6865 3.74495 8.88405 2.61328 6.99988 2.61328Z",
    fill: "#3D3962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/ic_view.32d3124bd79d525f965c8963fb85a7c4.svg";
export { ForwardRef as ReactComponent };